import React, { Component, useEffect, useState } from 'react';
import {ReactComponent as Trophy} from '../../Assets/Images/trophy.svg'


const TopFiftyPrimary = () => {
    const[data, setData] = useState('');

    const now = new Date();
    const formatForUrl = (date) => date.toLocaleDateString('en-CA'); // YYYY-MM-DD
    const formatForTitle = (date) =>
    date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = now;

    const startDateText = formatForTitle(start);
    const endDateText = formatForTitle(end);


    useEffect(() => {
        async function fetchTop() {
            const response = await fetch(`https://deals.axcrm.ae/backend/api/get-top-agents?key=${process.env.REACT_APP_AXDEALS_API_KEY}&start_date=${formatForUrl(start)}&end_date=${formatForUrl(end)}&is_split=1&items_per_page=10`);
            const json = await response.json();
            setData(json.top_50)
        }
        fetchTop();
    }, []);



    const filledData = Array.from({ length: 10 }, (_, i) => {
    const item = data?.[i];
    return item
        ? { name: item.name || item.Agent || '', value: item.values ?? '' }
        : { name: '', value: '' };
    });

    const firstHalf = filledData.slice(0, 5);
    const secondHalf = filledData.slice(5, 10);

    const getColorByRank = (index) => {
        switch (index) {
            case 0: return '#FFD700'; // Gold
            case 1: return '#C0C0C0'; // Silver
            case 2: return '#CD7F32'; // Bronze
            default: return '#202024'; // Gray for others
        }
    };

    console.log(filledData)

  return (
    <div className="container-fluid">
      <div className="height-board align-items-center">
        <div className="card list-board">
          <div className="row">
            <div className="col-md-12">
              <h3 className="title">🏆 TOP 10 Agents from {startDateText} - {endDateText}</h3>
            </div>
          </div>
          <div className="row lists h-100 dealday">
            <div className="col-md-8 offset-md-2">
              <div className="h-100 list-deal deal-1">
                <ul>
                  {filledData.map((item, index) => (
                    <li key={index} className="d-flex">
                        <span>{index+1}. {item.name}</span>
                        <Trophy style={{
                            fill: getColorByRank(index)
                        }} />
                      <span>{item.value.split(".")[0]} AED</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {/* <div className="col-md-5">
              <div className="h-100 list-deal deal-2">
                <ul>
                  {secondHalf.map((item, index) => (
                    <li key={index} className="d-flex">
                      <span>{item.name}</span>
                      <span>{item.value.split(".")[0]} AED</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopFiftyPrimary;
